"use strict";

module.exports = {
  bootstrap: function bootstrap() {
    global.googletag = global.googletag || {};
    global.googletag.cmd = global.googletag.cmd || [];
  }
};